// extracted by mini-css-extract-plugin
export default {"testo":"DatiSegnalazioneAnagrafici_testo__eoWYn","hr":"DatiSegnalazioneAnagrafici_hr__Xn7GW","fieldContainer":"DatiSegnalazioneAnagrafici_fieldContainer__G+G9X"};